import {AppMenuConfig} from './menuConfig';
import {RenderConfigModel} from '../_models/CapaModels/RenderConfig.model';
import {Subject, Subscription} from 'rxjs';
import {AppGlobal} from '../../environments/app.global';
import {Inject} from '@angular/core';

export class RendererService {

    appGlobalConfig: AppGlobal;

    private configSubject: Subject<RenderConfigModel> = new Subject<RenderConfigModel>();
    private configObservable: Subscription = this.configSubject.asObservable().subscribe((MyRenderer) => {
        this._config = MyRenderer;
    });

    private _config: RenderConfigModel;
    public currentConfig: string ;

    constructor(@Inject(AppGlobal) AppGlobalConfig: AppGlobal) {
        this.appGlobalConfig = AppGlobalConfig;
        this.configure('');
    }

    configure(url: string) {
        switch (url) {
            case 'capa':
                if (this.currentConfig !== this.appGlobalConfig.Apps.CAPA) {
                    const renderConfigModel = new RenderConfigModel();
                    renderConfigModel.logoMini = AppMenuConfig.capa.logoMini;
                    renderConfigModel.logoLarge = AppMenuConfig.capa.logoLarge;
                    renderConfigModel.color = AppMenuConfig.capa.color;
                    renderConfigModel.menu = AppMenuConfig.capa.menu;

                    this.configSubject.next(renderConfigModel);

                    this.currentConfig = this.appGlobalConfig.Apps.CAPA;
                    this._config = renderConfigModel;
                }
                break;

            default:
                if (this.currentConfig !== this.appGlobalConfig.Apps.CLHUB) {
                    const renderConfigModel = new RenderConfigModel();
                    renderConfigModel.logoMini = AppMenuConfig.powerBi.logoMini;
                    renderConfigModel.logoLarge = AppMenuConfig.powerBi.logoLarge;
                    renderConfigModel.color = AppMenuConfig.powerBi.color;
                    renderConfigModel.menu = AppMenuConfig.powerBi.menu;

                    this.configSubject.next(renderConfigModel);

                    this.currentConfig = this.appGlobalConfig.Apps.CLHUB;
                    this._config = renderConfigModel;
                }
                break;
        }
    }

    get config(): RenderConfigModel {
        return this._config;
    }

    set config(value: RenderConfigModel) {
        this._config = value;
    }
}
